import { useAnalytics } from "~/components/Analytics";
import { LandingPageContainer } from "~/components/LandingPageV2/components/LandingPageContainer";
import { LandingPageContent } from "~/components/LandingPageV2/components/LandingPageContent";
import { LandingPageCTAs } from "~/components/LandingPageV2/components/LandingPageCTAs";
import { SplitWithImageContainer } from "~/components/LandingPageV2/components/SplitWithImageContainer";
import { LandingPageBuildHtml } from "~/components/LandingPageV2/LandingPageBuildHtml";
import {
  HeroFullWidth,
  HeroSplitWithImage,
} from "~/components/LandingPageV2/schemas";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";

type LandingPageHeroProps = (HeroFullWidth | HeroSplitWithImage) & {
  highlightBlock?: boolean;
};

export const LandingPageHero: React.FC<LandingPageHeroProps> = (props) => {
  const {
    appearance,
    maxWidth,
    wysiwyg,
    background,
    ctaAlignment,
    includeCtas,
    primaryCta,
    secondaryCta,
    highlightBlock,
  } = props;

  const { analyticsEnhancedTrack } = useAnalytics();

  const primaryButtonClick = () =>
    analyticsEnhancedTrack("Clicked Primary CTA", {
      context: "hero",
      linkText: getValueOrDefault(primaryCta?.title, null),
      linkUrl: getValueOrDefault(primaryCta?.url, null),
    });

  const secondaryButtonClick = () =>
    analyticsEnhancedTrack("Clicked Secondary CTA", {
      context: "hero",
      linkText: getValueOrDefault(secondaryCta?.title, null),
      linkUrl: getValueOrDefault(secondaryCta?.url, null),
    });

  if (appearance === "split_with_image") {
    return (
      <LandingPageContainer
        background={background}
        className="py-xl lg:py-xxl"
        topPadding="xxLarge"
        bottomPadding="xxLarge"
        blockInfo={{ blockIndex: 0, blockType: "hero" }}
        shouldShowBlockSkeleton={highlightBlock}
      >
        <LandingPageContent maxWidth={maxWidth}>
          <SplitWithImageContainer
            imageAlt={props.image.alt}
            imageUrl={props.image.url}
            imagePosition="left"
            mdImagePosition={props.imagePosition}
            verticalTextAlignment="top"
          >
            <div>
              <LandingPageBuildHtml html={wysiwyg} />
              <LandingPageCTAs
                includeCtas={includeCtas}
                ctaAlignment={ctaAlignment}
                onPrimaryClick={primaryButtonClick}
                onSecondaryClick={secondaryButtonClick}
                primaryCta={primaryCta}
                secondaryCta={secondaryCta}
              />
            </div>
          </SplitWithImageContainer>
        </LandingPageContent>
      </LandingPageContainer>
    );
  }

  return (
    <LandingPageContainer
      background={background}
      className="py-xl lg:py-xxl"
      topPadding="xxLarge"
      bottomPadding="xxLarge"
      blockInfo={{ blockIndex: 0, blockType: "hero" }}
      shouldShowBlockSkeleton={highlightBlock}
    >
      <LandingPageContent maxWidth={maxWidth}>
        <div>
          <LandingPageBuildHtml html={wysiwyg} />
          <LandingPageCTAs
            includeCtas={includeCtas}
            ctaAlignment={ctaAlignment}
            onPrimaryClick={primaryButtonClick}
            onSecondaryClick={secondaryButtonClick}
            primaryCta={primaryCta}
            secondaryCta={secondaryCta}
          />
        </div>
      </LandingPageContent>
    </LandingPageContainer>
  );
};
